import React, { useEffect, useState } from "react";
import { ProcessesVM } from "../../../Models/ViewModels";
import { GetUserLoginID } from "../../../Services/UserSessionManager";
import { ToastContainer, toast } from 'react-toastify';
import ModalHeader from "rsuite/esm/Modal/ModalHeader";
import ModalTitle from "rsuite/esm/Modal/ModalTitle";
import ModalBody from "rsuite/esm/Modal/ModalBody";
import { Button, Input, Modal } from "rsuite";
import { AddProcess, DeleteProcess, EditProcess } from "../../../Services/ProcessDB";
type attributes = {
 
    type:string,
    title:string  , 
    data:ProcessesVM;
    onAction: any;
    cachedData:Array<ProcessesVM>;
  }

  export const AddEditDeleteProcess=(props:attributes)=>{
    const[loginid,setLoginid]=useState(GetUserLoginID())
    const[newProcess,setNewProcess]=useState(new ProcessesVM())
    const [open, setOpen] = React.useState(true);
  const [displayButton,setDisplayButton]=useState(false)


  useEffect(() => {
    setNewProcess(props.data)
    if(props.type=='edit')
    {
   
      setDisplayButton(true)
    }
  }, []) 
    const handleClose = () =>{
        setOpen(false);
        }
    const handelProcessModification=()=>{
        if(props.type=='edit'){
            EditProcess(newProcess,loginid).then((res)=>{
                props.onAction();
                handleClose();
                   toast.info("Updated successfully !");
            }).catch((err)=>{
                toast.error("Failed to Update !");}
            )
        }

         else if(props.type=='add'){
            AddProcess(newProcess,loginid).then((res)=>{
              if(res.data==1){
                props.onAction();
                handleClose();
                 toast.success("Added successfully")
              }
              else
                toast.error("Account trying to add is already Active!")
            }).catch((err)=>{
                toast.error("Failed to Add !")
            })
        }
        else if(props.type=='delete'){
            DeleteProcess(newProcess.ProcessID).then((res)=>{
                props.onAction();
                handleClose();
               toast.error("Deleted successfully")
            }).catch((err)=>{
                toast.error("Failed to Delete !");
            })
        }
    }

    const handleInput = (value:any,event:any) => {
        console.log(event)
        let value1 = event.target.type === 'number' ? +event.target.value : event.target.value;
        setNewProcess({...newProcess, [event.target.name]:value1});
        
    }
    if(props.type=='delete'){
        return(
        <div className="modal-container">
       <ModalHeader>
         <ModalTitle><h4>{props.title}</h4></ModalTitle>
       </ModalHeader>
       <ModalBody>
        Are you sure you want to delete {newProcess.ProcessName}
       </ModalBody>
       <Modal.Footer>
              <Button onClick={handelProcessModification} appearance="primary">
              Delete
              </Button>
            </Modal.Footer>
       </div>
        )
      }
    else{
        return (
            <div className="modal-container"> 
                <Modal.Header>
                  <Modal.Title><h3>{props.title}</h3></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <ModalTitle >Process Name</ModalTitle>
                <Input  type="text" name="ProcessName" value={newProcess.ProcessName} onChange={(value,event)=>handleInput(value,event)}/>
                <ModalTitle >Process Code</ModalTitle>
                <Input type="text" name="ProcessCode" value={newProcess.ProcessCode} onChange={(value,event)=>handleInput(value,event)}/>
        
                </Modal.Body>
                {displayButton?
                    <Modal.Footer>   <Button onClick={handelProcessModification} appearance="primary">
                    Update
                    </Button> 
                    </Modal.Footer>
                    :
                    <Modal.Footer><Button onClick={handelProcessModification} appearance="primary">
                     Add
                    </Button>
                    </Modal.Footer>
                }
            </div>
        )
                
    }
     
  }